export default __webpack_public_path__ + "static/media/email-inbox-icon.b79ccf14.svg";